export default __webpack_public_path__ + "static/animation-eeab11538c46d7d2170e817782d89a4d.mp4";